var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.iframeUrl)?_c('iframe',{staticClass:"w-screen h-screen overflow-y-hidden",attrs:{"title":"","src":_vm.iframeUrl,"sandbox":"allow-forms allow-scripts allow-modals allow-popups allow-same-origin allow-top-navigation","allowfullscreen":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }